import { combineReducers } from "redux";
import AddToCart from "./addToCart";
import AddToWhishList from "./addToWhishlist";

const rootReducer = combineReducers({
  AddToCart,
  AddToWhishList,
});

export default rootReducer;
